<template>
  <div>
    <div class="right-tools-container">
      <div class="top-tool" @mouseover="showRankDetail = true" style="padding: 10px;cursor: pointer"
        @click="showRankDetail = !showRankDetail"
        v-if="(activityInfo.rankWeekOpen == 1 || activityInfo.rankTotalOpen == 1 || activityInfo.rankTxOpen == 1)">
        <div class="flex flex-direction align-center">
          <img style="width: 28px;height: 32px;margin-bottom: 6px" src="../../assets/gfMoney/num1.png">
          <div class="k-title">榜</div>
          <div class="k-title">行</div>
          <div class="k-title">榜</div>
          <i class="el-icon-arrow-left" v-if="!showRankDetail" style="color: #D4D5D6;margin-top: 8px"></i>
          <i class="el-icon-arrow-right" v-else style="color: #D4D5D6;margin-top: 8px"></i>
        </div>
      </div>
      <div class="rank-box" @mouseleave="showRankDetail = false"
        v-if="(activityInfo.rankWeekOpen == 1 || activityInfo.rankTotalOpen == 1 || activityInfo.rankTxOpen == 1) && showRankDetail">
        <div class="flex align-center justify-around" style="margin-bottom: 4px">
          <div class="tab-item" :class="activeItem === 1 ? 'active-item' : 'active-default'" @click="changeItem(1)"
            v-if="activityInfo.rankWeekOpen == 1">周榜</div>
          <div class="tab-item" :class="activeItem === 2 ? 'active-item' : 'active-default'" @click="changeItem(2)"
            v-if="activityInfo.rankTotalOpen == 1">总榜</div>
          <div class="tab-item" :class="activeItem === 3 ? 'active-item' : 'active-default'" @click="changeItem(3)"
            v-if="activityInfo.rankTxOpen == 1">提现榜</div>
        </div>
        <div class="rank-item flex align-center" v-for="(item, index) in rankList" :key="index">
          <div class="flex align-center justify-center" style="width: 28px;height: 32px;margin-right: 28px">
            <img style="width: 28px;height: 32px;margin-left: 20px" v-if="index === 0"
              src="../../assets/gfMoney/num1.png">
            <img style="width: 28px;height: 32px;margin-left: 20px" v-if="index === 1"
              src="../../assets/gfMoney/num2.png">
            <img style="width: 28px;height: 32px;margin-left: 20px" v-if="index === 2"
              src="../../assets/gfMoney/num3.png">
            <div v-if="index > 2" class="rank-num">{{ index + 1 }}</div>
          </div>
          <el-avatar :size="30" icon="el-icon-user-solid"
            :src="item.headImgUrl ? linkAllImgUrl(item.headImgUrl) : ''"></el-avatar>
          <div class="username text-line-1">{{ hiddenStr(item.fullName) }}</div>
          <div class="" v-if="activeItem < 3">
            <span class="label">已上传：</span>
            <span class="value">{{ item.uploadNum }}个模型</span>
          </div>
          <div class="" v-else>
            <span class="label">已瓜分：</span>
            <span class="value" style="color:#FA5C5C;">¥{{ item.totalMoney }}.00</span>
          </div>
        </div>
        <div class="join-btn" @click="toHd" v-if="!$store.state.IsHdPage">参与活动</div>
        <div class="join-btn" @click="tofbzc" v-if="$store.state.IsHdPage">上传模型</div>
      </div>

      <rightMemTxt class="bgc"></rightMemTxt>

      <ul class="top-tool">
        <li @mouseenter="mouseEnterMine()" @mouseleave="mouseLeaveMine()" @click="goPage('/user/account')">
          <img class="out" src="../../assets/member/wcharts.png" alt="">
          <transition name="fade">
            <div class="on" v-if="mineToolsShow">
              <p>充值</p>
              <img src="../../assets/member/charts.png" alt="" class="icon" />
            </div>
          </transition>
        </li>
        <li @mouseenter="mouseEnterShop()" @mouseleave="mouseLeaveShop()" @click="openCart()">
          <img src="../../assets/tools/shop-out.png" alt="" class="out" />
          <transition name="fade">
            <div class="on" v-if="ShopToolsShow">
              <p>购物车</p>
              <img src="../../assets/tools/shop-on.png" alt="" class="icon" />
            </div>
          </transition>
        </li>
        <li @mouseenter="mouseEnterNotice()" @mouseleave="mouseLeaveNotice()" @click="goPage('/user/notice')">
          <img src="../../assets/tools/notice-out.png" alt="" class="out" />
          <transition name="fade">
            <div class="on" v-if="noticeToolsShow">
              <p>消息中心</p>
              <img src="../../assets/tools/notice-on.png" alt="" class="icon" />
            </div>
          </transition>
        </li>
        <li @mouseenter="mouseEnterSearch()" @mouseleave="mouseLeaveSearch()">
          <img src="../../assets/tools/search-out.png" alt="" class="out" />
          <transition name="fade">
            <div class="on chance" v-if="searchTollsShow">
              <input type="text" placeholder="请输入搜索内容" @keyup.enter="searchFunc()" autocomplete="off" v-model="searchText"
                @change="searchChange()" />
              <img src="../../assets/tools/search-on.png" alt="" class="icon" />
            </div>
          </transition>
        </li>
      </ul>
      <ul class="bottom-tools">
        <li @mouseenter="mouseEnterQrcode()" @mouseleave="mouseLeaveQrcode()">
          <div class="icon" :class="{ active: qrcodeToolsShow }">
            <img src="../../assets/tools/windows.png" alt="" class="out">
            <img src="../../assets/tools/windows-on.png" alt="" class="on">
          </div>
          <div class="code-box" v-if="qrcodeToolsShow">
            <div class="code">
              <img src="../../assets/tools/qrcode.png" alt="">
              <p>
                关注公众号
              </p>
            </div>
          </div>
        </li>
        <li @mouseenter="mouseEnterService()" @mouseleave="mouseLeaveService()">
          <div class="icon" :class="{ active: serviceToolsShow }">
            <img src="../../assets/tools/earphone.png" alt="" class="out">
            <img src="../../assets/tools/earphone-on.png" alt="" class="on">
          </div>
          <div class="code-box" v-if="serviceToolsShow">
            <div class="code">
              <img src="../../assets/link.png" alt="">
              <p>
                扫码联系客服
              </p>
            </div>
          </div>
        </li>
        <li @mouseenter="mouseEnterRocket()" @mouseleave="mouseLeaveRocket()">
          <div class="icon" :class="{ active: rocketToolsShow }" @click.stop="backTop()">
            <img src="../../assets/tools/plane.png" alt="" class="out">
            <img src="../../assets/tools/plane-on.png" alt="" class="on">
          </div>
        </li>
      </ul>
    </div>
    <openMembership v-if="isvisible" @memberHidden="memberHidden"></openMembership>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { getActivityInfo, getRankTotalApi, getRankUploadApi, getRankWeekApi } from "@/api/activity";
import commonMixin from "@/mixins/commonMixin";
import openMembership from '@/components/openMembership/index.vue'
import rightMemTxt from '@/components/rightMemTxt/index.vue'
export default {
  mixins: [commonMixin],
  components: {
    openMembership,
    rightMemTxt
  },
  data () {
    return {
      isvisible: false,
      mineToolsShow: false,
      ShopToolsShow: false,
      noticeToolsShow: false,
      searchTollsShow: false,
      qrcodeToolsShow: false,
      serviceToolsShow: false,
      rocketToolsShow: false,
      searchText: "",
      showRankDetail: false,
      activeItem: 1,
      rankList: [],
      activityInfo: {},
      totalRankList: [],
      weekRankList: [],
      uploadRankList: [],
      isMoving: false,
      interval: null,
      backPosition: 0
    };
  },
  computed: {
    ...mapGetters(["GET_USER_INFO", 'GET_CART_BADGE', 'GET_BELL_BADGE']),
  },
  created () {
    this.getActivity();
  },
  beforeDestroy () {

    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    ...mapMutations({
      REMOVE_USER_INFO: "REMOVE_USER_INFO",
      SET_CART_VISIBLE: "SET_CART_VISIBLE",
      SET_BELL_BADGE: "SET_BELL_BADGE",
      SET_CART_BADGE: "SET_CART_BADGE",
    }),
    getActivity () {
      getActivityInfo().then(res => {
        this.activityInfo = res.data
        if (this.activityInfo.id) {
          if (this.activityInfo.rankWeekOpen == 1) {
            this.getRankWeek()
          }
          if (this.activityInfo.rankTxOpen == 1) {
            this.getRankTotal()
          }
          if (this.activityInfo.rankTotalOpen == 1) {
            this.getRankUpload()
          }
        }
      })
    },
    getRankTotal () {
      getRankTotalApi({ activityId: this.activityInfo.id }).then(res => {
        this.totalRankList = res.data
        this.changeItem(3)
      })
    },
    getRankWeek () {
      getRankWeekApi({ activityId: this.activityInfo.id }).then(res => {
        this.weekRankList = res.data
        this.changeItem(1)
      })
    },
    getRankUpload () {
      getRankUploadApi({ activityId: this.activityInfo.id }).then(res => {
        this.uploadRankList = res.data
        this.changeItem(2)
      })
    },
    toHd () {
      this.$router.push(`/gfMoney`)
    },
    tofbzc () {
      this.$router.push(`/user/resource`)
    },
    hiddenStr (name) {
      let newStr;
      if (name.length === 2) {
        newStr = name.substr(0, 1) + '*';
      } else if (name.length > 2) {
        let char = '';
        for (let i = 0, len = name.length - 2; i < len; i++) {
          char += '*';
        }
        newStr = name.substr(0, 1) + char + name.substr(-1, 1);
      } else {
        newStr = name;
      }
      return newStr;
    },
    changeItem (i) {
      this.activeItem = i
      console.log(i)
      if (i == 1) {
        this.rankList = this.weekRankList
      }
      if (i == 2) {
        this.rankList = this.uploadRankList
      }
      if (i == 3) {
        this.rankList = this.totalRankList
      }
    },
    mouseEnterMine () {
      this.mineToolsShow = true;
    },
    mouseLeaveMine () {
      this.mineToolsShow = false;
    },
    mouseEnterShop () {
      this.ShopToolsShow = true;
    },
    mouseLeaveShop () {
      this.ShopToolsShow = false;
    },
    mouseEnterNotice () {
      this.noticeToolsShow = true;
    },
    mouseLeaveNotice () {
      this.noticeToolsShow = false;
    },
    mouseEnterSearch () {
      this.searchTollsShow = true;
    },
    mouseLeaveSearch () {
      this.searchTollsShow = false;
    },
    mouseEnterQrcode () {
      this.qrcodeToolsShow = true;
    },
    mouseLeaveQrcode () {
      this.qrcodeToolsShow = false;
    },
    mouseEnterService () {
      this.serviceToolsShow = true;
    },
    mouseLeaveService () {
      this.serviceToolsShow = false;
    },
    mouseEnterRocket () {
      this.rocketToolsShow = true;
    },
    mouseLeaveRocket () {
      this.rocketToolsShow = false;
    },
    goPage (url) {
      // 跳转用户个人中心
      // console.log('this.GET_USER_INFO.token :>> ', this.GET_USER_INFO.token);
      if (this.GET_USER_INFO.token) {
        this.$router.push(url);
      } else {
        // 没登录跳转登录页面
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      }
    },
    openCart () {
      // 查看购物车
      if (this.GET_USER_INFO.token) {
        this.SET_CART_VISIBLE(true)
      } else {
        // 没登录跳转登录页面
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      }
    },
    searchFunc () {
      const query = this.searchText;
      if (query) {
        localStorage.setItem("searchText", name);
        this.$router.push({
          path: '/search',
          query: {
            name: query
          }
        })
      } else {
        localStorage.removeItem("searchText");
      }
    },
    searchChange () {
      if (!this.searchText) {
        localStorage.removeItem("searchText");
      }
    },
    backTop () {

      if (this.isMoving) return;
      const start = window.pageYOffset;

      let i = 0;
      this.isMoving = true;
      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition);
          clearInterval(this.interval);
          this.isMoving = false;
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 16.7);
    },
    easeInOutQuad (t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
      return (-c / 2) * (--t * (t - 2) - 1) + b;
    },
    pointsLayerVisClick () {
      if (this.GET_USER_INFO.token === '') { // 用户没登录
        this.$router.push({ path: '/member' })
      } else { // 用户已登录
        this.isvisible = true
      }
    },
    memberHidden (val) {
      this.isvisible = val
    }

  },
};
</script>

<style lang="less" scoped>
.join-btn {
  margin-left: 60px;
  margin-top: 10px;
  width: 200px;
  height: 35px;
  background: #FA5C5C;
  border-radius: 18px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 35px;
  text-align: center;
  cursor: pointer;
}

.rank-num {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #305C62;
  margin-left: 20px;
}

.rank-item {
  height: 50px;
  width: 100%;
  border-top: 1px solid #EEEEEE;

  .username {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #363636;
    margin-left: 16px;
    width: 80px;
  }

  .label {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }

  .value {
    font-family: Microsoft YaHei;
    color: #363636;
    font-size: 12px;
    display: inline-block;
  }
}

.tab-item {
  width: 56px;
  height: 47px;
  line-height: 47px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
}

.active-item {
  color: #FA5C5C;
  border-bottom: 2px solid #FA5C5C;
}

.active-default {
  color: #363636;
  border-bottom: 2px solid #FFFFFF;
}

.rank-box {
  position: absolute;
  right: 60px;
  top: -100px;
  width: 320px;
  height: 363px;
  background: #FFFFFF;
  box-shadow: -2px 0px 10px 0px rgba(35, 29, 30, 0.1);
  border-radius: 20px 0px 0px 20px;
  cursor: pointer;

  .hidden-btn {
    position: absolute;
    left: -30px;
    top: 142px;
    width: 30px;
    height: 70px;
    background: #DCDCDC;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #363636;
    line-height: 22px;
    cursor: pointer;
  }
}

.k-title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #363636;
  line-height: 22px;

}

.right-tools-container {
  position: fixed;
  bottom: 72px;
  right: 0;
  z-index: 500;

  .top-tool {
    box-sizing: border-box;
    border-radius: 10px 0 0 10px;
    box-shadow: -2px 0px 10px 0px rgba(35, 29, 30, 0.07);
    background: #fff;
    margin-bottom: 10px;

    li {
      position: relative;
      padding: 20px 15px;
      cursor: pointer;

      .fade-enter-active,
      .fade-leave-active {
        transition: opacity 0.5s;
      }

      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }

      .out {
        display: block;
        height: 22px;
      }

      .on {
        position: absolute;
        top: 10px;
        right: 0;
        display: flex;
        width: 130px;
        align-items: center;
        justify-content: flex-end;
        box-sizing: border-box;
        padding: 10px 15px;
        background: #1c6f6e;
        border-radius: 20px 0 0 20px;

        p {
          font-size: 16px;
          color: #fff;
          margin-right: 15px;
        }

        .icon {
          display: block;
          height: 20px;
        }

        &.chance {
          width: 230px;

          .icon {
            margin-left: 10px;
          }

          input[type="text"] {
            display: block;
            width: 90%;
            border: none;
            background: none;
            font-size: 16px;
            color: #fff;
            outline: none;

            &::placeholder {
              font-size: 16px;
              color: #fff;
            }
          }
        }
      }
    }
  }

  .bgc {
    margin-bottom: 10px;
  }

  .memberTool {
    margin-bottom: 10px;
    width: 60px;
    height: 140px;
    background-color: #ccc;
    border-radius: 8px;
    color: #000;
    font-size: 16px;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    padding-top: 15px;

    li {
      margin-bottom: 8px;
    }

  }

  .bottom-tools {
    box-sizing: border-box;
    border-radius: 10px 0 0 10px;
    box-shadow: -2px 0px 10px 0px rgba(35, 29, 30, 0.07);
    background: #fff;

    li {
      position: relative;
      padding: 20px 15px;
      cursor: pointer;

      .icon {
        height: 22px;

        &.active {

          img {

            &.out {
              display: none;
            }

            &.on {
              display: block;
            }
          }
        }

        img {
          display: block;
          width: auto;
          height: 100%;

          &.on {
            display: none;
          }
        }
      }

      .code-box {
        position: absolute;
        top: 10px;
        right: calc(100% + 10px);
        background: #fff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .code {
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }

          img {
            display: block;
            width: 70px;
            margin: 0 auto;
            padding-top: 6px;
          }

          p {
            font-size: 14px;
            color: #969696;
            padding: 6px 7px;
            text-align: center;
            white-space: nowrap;
          }
        }
      }
    }
  }

}
</style>
